/* eslint-disable no-unused-vars */
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { axiosBaseQuery } from '../axios/index';

export const accountSettingsAPI = createApi({
  reducerPath: 'AccountSettingsAPI',
  baseQuery: axiosBaseQuery({ baseUrl: '/api' }),
  tagTypes: ['AccountSettings/GetAccountSettingsData'],
  endpoints: (build) => ({
    GetAccountSettingsData: build.query({
      query: () => {
        return {
          url: `/AccountSettings/GetAccountSettingsData`,
          method: 'GET',
        };
      },
      keepUnusedDataFor: 0, //not cached
      providesTags: ['Account/GetAccountSettingsData'],
    }),
    SaveAccountSettingsPassword: build.mutation({
      query: (data) => ({
        url: `/AccountSettings/SaveAccountSettingsPassword`,
        method: 'POST',
        data,
      }),
      keepUnusedDataFor: 0, //not cached
      providesTags: ['Account/SaveAccountSettingsPassword'],
    }),
    SaveAccountSettingsData: build.mutation({
      query: (data) => ({
        url: `/AccountSettings/SaveAccountSettingsData`,
        method: 'POST',
        data,
      }),
      keepUnusedDataFor: 0, //not cached
      providesTags: ['Account/SaveAccountSettingsData'],
    }),
    ValidateNewEmailAddress: build.mutation({
      query: (data) => ({
        url: `/AccountSettings/ValidateNewEmailAddress`,
        method: 'POST',
        data,
      }),
      keepUnusedDataFor: 0, //not cached
      providesTags: ['AccountSettings/ValidateNewEmailAddress'],
    }),
  }),
});
